import { useState } from 'react';
import { Icon } from './Icons.tsx';

/** Shows freshly generated recovery codes once, with copy/download, until the user confirms they saved them. */
export default function RecoveryCodes({ codes, email, onDone, doneLabel = 'Continue' }: {
  codes: string[]; email: string; onDone: () => void; doneLabel?: string;
}) {
  const [saved, setSaved] = useState(false);
  const [copied, setCopied] = useState(false);
  const text = `Edgebook recovery codes for ${email}\nEach code works once. Use one on the sign-in page under "Forgot password?".\n\n${codes.join('\n')}\n`;

  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch { /* clipboard blocked; the codes are still on screen */ }
  }

  function download() {
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = 'edgebook-recovery-codes.txt';
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div className="stack" style={{ gap: 12 }}>
      <p className="muted" style={{ margin: 0 }}>
        If you ever forget your password, any one of these codes lets you set a new one. Each code works once.
        Save them in your password manager or somewhere safe. <b style={{ color: 'var(--text)' }}>You won't see them again.</b>
      </p>
      <div className="codes mono">
        {codes.map((c) => <span key={c}>{c}</span>)}
      </div>
      <div className="row wrap">
        <button type="button" className="small" onClick={copy}>{copied ? <><Icon.check /> Copied</> : 'Copy'}</button>
        <button type="button" className="small" onClick={download}>Download .txt</button>
      </div>
      <label className="row" style={{ gap: 8, cursor: 'pointer' }}>
        <input type="checkbox" checked={saved} onChange={(e) => setSaved(e.target.checked)} style={{ minHeight: 0, width: 18, height: 18 }} />
        I saved my recovery codes
      </label>
      <button type="button" className="primary" disabled={!saved} onClick={onDone}>{doneLabel}</button>
    </div>
  );
}
